export default "__VITE_ASSET__Bko3RRoO__"